import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import Header from "../../../components/header/Header";
import { selectedProject } from "../../home/appSlice/appslice";
import ShopEditReviewContainer from "../container/ShopEditReviewContainer";

const ShopDetailsPage = () => {
  const { id } = useParams()
  const project = useAppSelector(selectedProject)
  const navigate = useNavigate()

  useEffect(() => {
    if (!project) {
      navigate('/')
    }
  }, [project])

  return (
    <>
      {project && (
        <>
          <Header title="Shop Item" />
          <ShopEditReviewContainer id={id!} />
        </>
      )}
    </>
  )
}

export default ShopDetailsPage
